var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-status-pills"},[_c('span',{staticClass:"ai-main"},[_c('i',[_vm._v("✦")]),_vm._v(" AI自动优化图片并识别填充零件信息")])])
}]

export { render, staticRenderFns }